<template>
    <div>
        <div class="item w50">
            <div>选择商品</div>
            <div>
                <el-cascader ref="cascader" size="medium" v-model="productNameMsg" :options="productList" separator="·"
                    :props="props" @change="handleChange">
                </el-cascader>
            </div>
        </div>
        <div class="item" v-show="productName=='甲醇'">
            <div>商品信息</div>
            <div>
                <el-input type="textarea" placeholder="描述您的商品信息（选填）" v-model="details">
                </el-input>
            </div>
        </div>
        <div class="items">
            <div class="item item2">
                <div>竞拍模式</div>
                <div>
                    <el-radio-group v-model="pendingWay">
                        <el-radio-button label="明拍"></el-radio-button>
                        <el-radio-button label="暗拍"></el-radio-button>
                    </el-radio-group>
                </div>
            </div>
            <div class="item item2">
                <div>交货方式</div>
                <div>
                    <el-radio-group v-model="deliveryMethod">
                        <el-radio-button label="自提"></el-radio-button>
                        <el-radio-button label="派送"></el-radio-button>
                    </el-radio-group>
                </div>
            </div>
        </div>
        <div class="item w50">
            <div>{{deliveryMethod=='自提'?'自提仓库':'派送地址'}}</div>
            <div>
                <el-cascader v-show="deliveryMethod=='自提'" separator="-" :props="locationProps" size="medium"
                    v-model="locationList" :options="pickCityList" @change="locationChange"></el-cascader>
                <el-cascader v-show="deliveryMethod=='派送'" separator="-" size="medium" v-model="locationList"
                    :options="citys" @change="locationChange"></el-cascader>
            </div>
        </div>
        <div class="item item2" v-show="productName=='甲醇'">
            <div>货物品质</div>
            <div>
                <el-radio-group v-model="domestic">
                    <el-radio-button label="国产"></el-radio-button>
                    <el-radio-button label="进口"></el-radio-button>
                </el-radio-group>
                <div class="item"></div>
                <el-radio-group v-model="qualityOfGoods">
                    <el-radio-button label="优等品"></el-radio-button>
                    <el-radio-button label="一级品"></el-radio-button>
                    <el-radio-button label="粗醇"></el-radio-button>
                </el-radio-group>
                <div class="item"></div>
                <el-radio-group v-model="qualityOfGoodsOne">
                    <el-radio-button label="煤制"></el-radio-button>
                    <el-radio-button label="天然气制"></el-radio-button>
                    <el-radio-button label="焦炉气制"></el-radio-button>
                </el-radio-group>
            </div>
        </div>
        <div class="item" v-show="productName!='甲醇'">
            <div>商品信息</div>
            <div>
                <el-input type="textarea" placeholder="请描述货物品质···" v-model="description">
                </el-input>
            </div>
        </div>
        <div class="items">
            <div class="item" v-show="productName=='甲醇'">
                <div>乙醇含量</div>
                <div>
                    <el-input size="medium" placeholder="请输入内容" v-model="itemCharacteristics" class="input-with-select">
                        <template slot="prepend">小于</template>
                        <template slot="append">(单位PPM)</template>
                    </el-input>
                </div>
            </div>
            <div class="item">
                <div>交货周期</div>
                <div>
                    <el-input size="medium" placeholder="请选择交货天数" v-model="deliveryCycle" class="input-with-select"
                        @input="deliveryCycleChange">
                        <template slot="append">天</template>
                    </el-input>
                </div>
            </div>
        </div>
        <div class="items">
            <div class="item">
                <div>竞拍量</div>
                <div>
                    <el-input size="medium" placeholder="请输入竞拍总量" v-model="totalAmount" class="input-with-select"
                        @input="totalAmountChange">
                        <template slot="append">
                            <div>
                                <el-dropdown @command="handleCommand">
                                    <span class="el-dropdown-link blue pointer">
                                        {{numUnit}}<i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item v-for="(item,index) in numUnitList" :key="index"
                                            :command="item">
                                            {{item.numUnit}}
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </template>
                    </el-input>
                </div>
            </div>
            <div class="item">
                <div>起拍量</div>
                <div>
                    <el-input size="medium" placeholder="请输入起拍量" v-model="minSupply" class="input-with-select"
                        @input="minSupplyChange">
                        <template slot="append">
                            <div>
                                <el-dropdown @command="handleCommand">
                                    <span class="el-dropdown-link blue pointer">
                                        {{numUnit}}<i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item v-for="(item,index) in numUnitList" :key="index"
                                            :command="item">
                                            {{item.numUnit}}
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </template>
                    </el-input>
                </div>
            </div>
        </div>
        <div class="items">
            <div class="item">
                <div>底价</div>
                <div>
                    <el-input size="medium" placeholder="请输入抢购底价" v-model="price" @input="priceChange">
                        <template slot="append">
                            <div>
                                <el-dropdown @command="handleCommand2">
                                    <span class="el-dropdown-link blue pointer">
                                        元/{{unitedTitle}}<i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item v-for="(item,index) in unitedList" :key="index"
                                            :command="item">
                                            {{item.title}}
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </template>
                    </el-input>
                </div>
            </div>
            <div class="item" v-show="pendingWay=='明拍'">
                <div>加价梯度</div>
                <div>
                    <el-input size="medium" placeholder="请输入加价梯度" v-model="fareIncrease" @input="priceChange2">
                    </el-input>
                </div>
            </div>
        </div>
        <div class="item">
            <div>抢购时间</div>
            <div>
                <el-date-picker size="medium" value-format="yyyy-MM-dd HH:mm" v-model="validityStartTime"
                    type="datetime" placeholder="选择日期时间">
                </el-date-picker>
                <span>-</span>
                <el-date-picker size="medium" value-format="yyyy-MM-dd HH:mm" v-model="validityEndTime" type="datetime"
                    placeholder="选择日期时间">
                </el-date-picker>
            </div>
        </div>
        <div class="item item2">
            <div>付款方式</div>
            <div>
                <el-radio-group v-model="paymentMethod">
                    <el-radio-button label="先款"></el-radio-button>
                    <el-radio-button label="到付"></el-radio-button>
                </el-radio-group>
            </div>
        </div>
        <div class="item item2">
            <div>是否延时</div>
            <div>
                <el-radio-group v-model="isDelay">
                    <el-radio-button label="1">是</el-radio-button>
                    <el-radio-button label="2">否</el-radio-button>
                </el-radio-group>
            </div>
        </div>
        <div class="item item2">
            <div>是否公示最高价</div>
            <div>
                <el-radio-group v-model="isPublic">
                    <el-radio-button label="1">是</el-radio-button>
                    <el-radio-button label="2">否</el-radio-button>
                </el-radio-group>
            </div>
        </div>
        <div class="item item2">
            <div>指定参与方</div>
            <div>
                <el-radio-group v-model="isParticipants" @change="isParticipantsChange">
                    <el-radio-button label="1">确定</el-radio-button>
                    <el-radio-button label="0">取消</el-radio-button>
                </el-radio-group>
            </div>
        </div>
        <div class="mdList fz14" v-show="isParticipants==1">
            <div>
                <div>
                    <div class="c999">指定参与方列表</div>
                    <div class="blue pointer" @click="showUser=true">+继续添加</div>
                </div>
                <div>
                    <div v-for="(item,key) in userNameList" :key="key">{{item}}</div>
                </div>
            </div>
        </div>
        <div class="item item2">
            <div>添加黑名单</div>
            <div>
                <el-radio-group v-model="isParticipants" @change="isParticipantsChange">
                    <el-radio-button label="2">确定</el-radio-button>
                    <el-radio-button label="0">取消</el-radio-button>
                </el-radio-group>
            </div>
        </div>
        <div class="mdList fz14" v-show="isParticipants==2">
            <div>
                <div>
                    <div class="c999">黑名单列表</div>
                    <div class="blue pointer" @click="showUser=true">+继续添加</div>
                </div>
                <div>
                    <div v-for="(item,key) in userNameList" :key="key">{{item}}</div>
                </div>
            </div>
        </div>
        <div class="item item3">
            <div>货物图片</div>
            <div>
                <el-upload class="avatar-uploader" action="/" :show-file-list="false" :auto-upload="false"
                    :on-change="imgChange">
                    <img v-if="img" :src="img" class="avatar">
                    <i v-if="!img" class="el-icon-plus avatar-uploader-icon"></i>
                    <div v-if="!img" class="avatar-uploader-txt">点击上传</div>
                </el-upload>
            </div>
        </div>
        <div class="btn">
            <div @click="previewConfirm">确定发布</div>
            <!-- <div>引用上次</div> -->
        </div>

        <div class="mark" v-show="showUser"></div>
        <div class="userList" v-show="showUser">
            <div>
                <div>请选择参与方</div>
                <div class="pointer" @click="userClose"><i class="el-icon-close" style="cursor: pointer;"></i></div>
            </div>
            <div>
                <el-input size="medium" placeholder="请输入公司名称或者用户姓名" suffix-icon="el-icon-search" v-model="userKw"
                    @input="getUserList">
                </el-input>
            </div>
            <div class="list">
                <div>
                    <el-checkbox-group v-model="checkList">
                        <div class="userItem" v-for="(item,index) in userList" :key="index">
                            <el-checkbox :label="item.userId">
                                <span class="c666 fz12">{{item.companyName}}</span>
                            </el-checkbox>
                        </div>
                    </el-checkbox-group>
                </div>
            </div>
            <div @click="userCofim">确定</div>
        </div>
    </div>
</template>

<script>
    import citys from '../../assets/citys.json'
    export default {
        name: "PublishJP",
        data() {
            return {
                value: '',
                props: {
                    value: 'id',
                    label: 'name',
                    expandTrigger: 'click',
                    lazy: true,
                    lazyLoad: this.lazyLoad
                },
                locationProps: {
                    value: 'text',
                    label: 'text',
                },
                productList: [],
                productNameMsg: '',

                productName: '',
                productValue: '',
                productCode: '',
                productId: '', //商品类型ID
                // title: '', //商品类型名称
                details: '', //商品描述-甲醇
                deliveryMethod: '自提', //交货方式
                location: '', //商品交付地址
                domestic: '国产', //是否国产
                qualityOfGoods: '优等品', //货物品质
                qualityOfGoodsOne: '煤制', //物品特性
                itemCharacteristics: '', //乙醇含量
                description: '', //货物品质描述-非甲醇
                deliveryCycle: '', //交货周期天数
                totalAmount: '', //总量
                minSupply: '', //最低供应量
                price: '', //底价
                unitedId: '1', //计价方式ID
                unitedTitle: '吨', //计价方式名称
                numUnit: '吨',
                margin: '1', //是否缴纳保证金-1：是-0：否
                marginQuota: 0, //保证金额度
                paymentMethod: '先款', //付款方式
                validityStartTime: '', //订单开始时间
                validityEndTime: '', //订单结束时间
                pendingWay: '明拍', //挂单方式
                isParticipants: '0', //是否使用黑白名单
                participants: '', //黑白名单列表
                files: '', //图片
                fareIncrease: '', //加价梯度
                isDelay: '1', //是否延时1-是，2-否
                isPublic: 1, //是否公示最高价(1：公示，2：不公示)，

                // productTypeList: [],
                // productListShow: false,

                // explain: false, //发布说明
                // marginExplain: false, //保证金说明
                // preview: false, //预览弹窗
                // marginIsShow: false, //保证金是否充足
                unitedList: [], //计价单位列表
                numUnitList: [], //计价单位列表
                // domesticList: ['国产', '进口'],
                // qualityOfGoodsList: ['优等品', '一级品', '粗醇'],
                // qualityOfGoodsOneList: ['煤制', '天然气制', '焦炉气制'],
                // locationPicker: false, //派送地址选择器
                // pickPicker: false, //自提地址选择器
                // unitedPick: false, //计价方式选择器
                // unitedPick2: false, //计价方式选择器
                // fareIncreasePick: false, //加价梯度选择器
                pickCityList: [], //自提地址列表
                citys: citys,
                locationList: [],
                // fareIncreasePickList: [{ //加价梯度选择器配置
                //     flex: 1,
                //     defaultIndex: 1,
                //     values: [0.01, 1, 2, 3, 4, 5, 10, 15, 20, 30, 50, 100],
                //     className: 'slot1',
                //     textAlign: 'center'
                // }],
                // unitedPickList2: [{ //计价方式选择器配置
                //     flex: 1,
                //     defaultIndex: 1,
                //     values: [],
                //     className: 'slot1',
                //     textAlign: 'center'
                // }],
                // unitedPickList: [{ //计价方式选择器配置
                //     flex: 1,
                //     defaultIndex: 1,
                //     values: [],
                //     className: 'slot1',
                //     textAlign: 'center'
                // }],
                // pickList: [{ //自提地址选择器配置
                //     flex: 1,
                //     defaultIndex: 1,
                //     values: '',
                //     className: 'slot1',
                //     textAlign: 'center'
                // }, {
                //     divider: true,
                //     content: '-',
                //     className: 'slot2'
                // }, {
                //     flex: 1,
                //     values: [],
                //     className: 'slot3',
                //     textAlign: 'center'
                // }],
                // locationList: [{ //派送地址选择器配置
                //     flex: 1,
                //     defaultIndex: 1,
                //     values: Object.keys(citys),
                //     className: 'slot1',
                //     textAlign: 'center'
                // }, {
                //     divider: true,
                //     content: '-',
                //     className: 'slot2'
                // }, {
                //     flex: 1,
                //     values: [],
                //     className: 'slot3',
                //     textAlign: 'center'
                // }, {
                //     divider: true,
                //     content: '-',
                //     className: 'slot4'
                // }, {
                //     flex: 1,
                //     values: [],
                //     className: 'slot5',
                //     textAlign: 'center'
                // }],
                // dateTime: false,

                // agent1: '', //中转参数
                // agent2: '', //中转参数
                // agent3: '', //中转参数
                // agent4: '', //中转参数
                // agent5: '', //中转参数
                // dateVal: new Date()

                img: '',


                showUser: false,
                userKw: '',
                userList: [],
                userNameList: [],
                checkList: []
            }
        },
        created() {
            this.getProductList();
            this.getunitedList();
            // this.getUserList();
        },
        methods: {
            //确定发布
            publishConfirm: function() {
                var that = this;
                var form = new FormData();

                if (that.files != '') {
                    form.append('files', that.files);
                }

                var obj = {
                    productId: that.productId,
                    isDelay: that.isDelay,
                    isPublic: that.isPublic / 1,
                    title: that.productName,
                    details: that.details,
                    biddingMode: that.pendingWay,
                    deliveryMethod: that.deliveryMethod,
                    location: that.location,
                    domestic: that.productName == '甲醇' ? that.domestic : '',
                    qualityOfGoods: that.productName == '甲醇' ? that.qualityOfGoods : '',
                    qualityOfGoodsOne: that.productName == '甲醇' ? that.qualityOfGoodsOne : '',
                    itemCharacteristics: that.itemCharacteristics,
                    deliveryCycle: that.deliveryCycle,
                    biddingAmount: that.totalAmount,
                    startingVolume: that.minSupply,
                    reservePrice: that.price,
                    marginQuota: that.marginQuota,
                    fareIncrease: that.fareIncrease,
                    paymentMethod: that.paymentMethod,
                    otherInstructions: '',
                    companyId: that.$store.state.userId,
                    companyName: that.$store.state.userName,
                    biddingStartTime: that.validityStartTime + ":00",
                    biddingEndTime: that.validityEndTime + ":00",
                    description: that.description,
                    unitedId: that.unitedId,
                    unitedTitle: that.unitedTitle,
                    numUnit: that.numUnit,
                    ouserId: that.$store.state.userId,
                    participants: that.isParticipants == '1' ? that.checkList.toString() : '',
                    isParticipants: that.isParticipants,
                    blacklists: that.isParticipants == '2' ? that.checkList.toString() : '',
                    productCode: that.productCode == '' || that.productCode == undefined ? null : that
                        .productCode,
                    productValue: that.productValue == '' || that.productValue == undefined ? null : that
                        .productValue
                }
                Object.keys(obj).forEach(function(key) {
                    form.append(key, obj[key]);
                });

                that.request.post(that.$store.state.frameworkUrl + 'deals/saveBiddingDeals', form, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(response => {
                    if (response.status == '200') {
                        that.$message({
                            message: '发布成功，请等待平台审核！',
                            type: 'success'
                        });
                        that.goRouter('/my_order');
                    } else {
                        that.$message.error(response.msg)
                    }
                })
            },
            //确定预览及参数判断
            previewConfirm: function() {
                let that = this;
                this.request.get(this.$store.state.httpUrl + "userDetails/findUserPerson", {
                    params: {
                        id: that.$store.state.userId,
						flag: that.$store.state.isPerson
                    }
                }).then(res => {
                    if (res.status == 200) {
                        if (res.data.isNotCertified != '2') {
                            that.$confirm('您好，您还没有认证，暂时不能操作，是否去认证?', '认证提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                that.$router.push({
                                    path: '/authentication',
                                    query: {

                                    }
                                });
                            }).catch(() => {});
                        } else {
                            nextStep();
                        }
                    }
                });

                function nextStep() {
                    if (!that.productName) {
                        that.$message({
                            message: '商品不能为空',
                            type: 'warning'
                        });
                        return false;
                    }

                    if (!that.location) {
                        that.$message({
                            message: '仓库地址或者派送地址不能为空',
                            type: 'warning'
                        });
                        return false;
                    }

                    if (that.productName != '甲醇') {
                        if (that.description == '') {
                            that.$message({
                                message: '货物品质描述不能为空',
                                type: 'warning'
                            });
                            return false;
                        }
                    }

                    if (that.deliveryCycle == '') {
                        that.$message({
                            message: '交货周期不能为空',
                            type: 'warning'
                        });
                        return false;
                    }

                    if (that.totalAmount == '') {
                        that.$message({
                            message: '总量不能为空',
                            type: 'warning'
                        });
                        return false;
                    }

                    if (that.productName == "甲醇") {
                        if ((that.totalAmount / 1) < 30) {
                            that.$message({
                                message: '总量必须大于等于30吨',
                                type: 'warning'
                            });
                            return false;
                        }
                        if (isTenMutiple_10(that.totalAmount / 1) == false) {
                            that.$message({
                                message: '总量必须为10的倍数',
                                type: 'warning'
                            });
                            return false;
                        }
                    } else {
                        if ((that.totalAmount / 1) <= 0) {
                            that.$message({
                                message: '总量必须大于0吨',
                                type: 'warning'
                            });
                            return false;
                        }
                    }

                    if (that.minSupply == '') {
                        that.$message({
                            message: '最低供应量不能为空',
                            type: 'warning'
                        });
                        return false;
                    }

                    if ((that.minSupply / 1) > (that.totalAmount / 1)) {
                        that.$message({
                            message: '最低供应量不能高于总量',
                            type: 'warning'
                        });
                        return false;
                    }

                    if (that.productName == "甲醇") {
                        if ((that.minSupply / 1) < 30) {
                            that.$message({
                                message: '最低供应量必须大于等于30吨',
                                type: 'warning'
                            });
                            return false;
                        }
                        if (isTenMutiple_10(that.minSupply / 1) == false) {
                            that.$message({
                                message: '最低供应量必须为10的倍数',
                                type: 'warning'
                            });
                            return false;
                        }
                    } else {
                        if ((that.minSupply / 1) <= 0) {
                            that.$message({
                                message: '最低供应量必须高于0吨',
                                type: 'warning'
                            });
                            return false;
                        }
                    }

                    if (that.price == '') {
                        that.$message({
                            message: '商品单价不能为空',
                            type: 'warning'
                        });
                        return false;
                    }

                    if (that.pendingWay == '明拍') {
                        if (that.fareIncrease == '0' || that.fareIncrease == '') {
                            that.$message({
                                message: '加价梯度不能为0',
                                type: 'warning'
                            });
                            return false;
                        }
                    } else {
                        that.fareIncrease = '0';
                    }

                    if (that.validityStartTime == '') {
                        that.$message({
                            message: '订单有效起始时间不能为空',
                            type: 'warning'
                        });
                        return false;
                    }

                    if (changeTime(that.validityStartTime) - getCurrentTime() < 120000) { //1200000-120000
                        that.$message({
                            message: '订单有效起始时间需晚于当前时间3分钟',
                            type: 'warning'
                        });
                        return false;
                    }

                    if (that.validityEndTime == '') {
                        that.$message({
                            message: '订单有效终止时间不能为空',
                            type: 'warning'
                        });
                        return false;
                    }
                    if (changeTime(that.validityStartTime) >= changeTime(that.validityEndTime)) {
                        that.$message({
                            message: '订单有效终止时间需晚于订单起始时间',
                            type: 'warning'
                        });
                        return false;
                    }

                    if (changeTime(that.validityEndTime) - changeTime(that.validityStartTime) > 43200000) {
                        that.$message({
                            message: '订单有效时间必须为12小时之内',
                            type: 'warning'
                        });
                        return false;
                    }

                    if (that.deliveryMethod == '') {
                        that.$message({
                            message: '交货方式不能为空',
                            type: 'warning'
                        });
                        return false;
                    }

                    if (that.paymentMethod == '') {
                        that.$message({
                            message: '付款方式不能为空',
                            type: 'warning'
                        });
                        return false;
                    }

                    if (that.pendingWay == '') {
                        that.$message({
                            message: '挂单方式不能为空',
                            type: 'warning'
                        });
                        return false;
                    }

                    if (that.checkList.length == '' && that.isParticipants == '1') {
                        that.$message({
                            message: '指定参与方不能为空',
                            type: 'warning'
                        });
                        return false;
                    } else if (that.checkList.length == '' && that.isParticipants == '2') {
                        that.$message({
                            message: '黑名单不能为空',
                            type: 'warning'
                        });
                        return false;
                    }

                    that.publishConfirm();
                }
                //把日期格式转换为时间戳
                function changeTime(str) {
                    var date = new Date(str);
                    var date = new Date(str.replace(/-/g, '/'));
                    return date.getTime();
                }
                //获取当前时间戳
                function getCurrentTime() {
                    return new Date().getTime();
                }
                //获取当前日期格式时间
                function getNowFormatDate() {
                    var date = new Date();
                    var seperator1 = "-";
                    var year = date.getFullYear();
                    var month = date.getMonth() + 1;
                    var strDate = date.getDate();
                    if (month >= 1 && month <= 9) {
                        month = "0" + month;
                    }
                    if (strDate >= 0 && strDate <= 9) {
                        strDate = "0" + strDate;
                    }
                    var currentdate = year + seperator1 + month + seperator1 + strDate;
                    return currentdate;
                }
                //是否为10的倍数
                function isTenMutiple_10(number) {
                    var isTen = number % 10;
                    if (isTen == 0) {
                        return true;
                    } else {
                        return false;
                    }
                }
                //是否为10000的倍数
                function isTenMutiple_10000(number) {
                    var isTen = number % 10000;
                    if (isTen == 0) {
                        return true;
                    } else {
                        return false;
                    }
                }
            },
            //选择地址
            locationChange(location) {
                if (location.length == 1) {
                    this.location = location[0];
                }
                if (location.length == 2) {
                    this.location = location[0] + location[1];
                }
                if (location.length == 3) {
                    this.location = location[0] + location[1] + location[2];
                }
            },
            //选择图片
            imgChange(file) {
                this.files = file.raw;
                this.img = URL.createObjectURL(file.raw);
            },
            //确定黑白名单
            userCofim() {
                let that = this;
                that.userNameList = [];
                that.userList.forEach(item => {
                    that.checkList.forEach(i => {
                        if (item.userId == i) {
                            that.userNameList.push(item.companyName);
                        }
                    })
                })
                that.showUser = false;
            },
            userClose() {
                this.checkList = [];
                this.showUser = false;
            },
            //黑白名单切换
            isParticipantsChange(value) {
                this.checkList = [];
                this.userNameList = [];
            },
            //选择计价单位
            handleCommand2(command) {
                this.unitedId = command.id;
                this.unitedTitle = command.title;
            },
            //选择数量单位
            handleCommand(command) {
                this.numUnit = command.numUnit;
            },
            //输入底价
            priceChange: function(e) {
                let value = e;
                value = value.replace(/[^\d.]/g, "");
                //必须保证第一个为数字而不是.
                value = value.replace(/^\./g, "");
                //保证只有出现一个.而没有多个.
                value = value.replace(/\.{2,}/g, ".");
                //保证.只出现一次，而不能出现两次以上
                value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");

                if (value / 1 < 0) {
                    value = 0;
                }
                if (value.toString().indexOf(".") != -1) {
                    if (value.toString().split(".")[1].length > 3) {
                        value = Math.floor(value * 1000) / 1000
                    }
                }
                this.price = value;
            },
            priceChange2: function(e) {
                let value = e;
                value = value.replace(/[^\d.]/g, "");
                //必须保证第一个为数字而不是.
                value = value.replace(/^\./g, "");
                //保证只有出现一个.而没有多个.
                value = value.replace(/\.{2,}/g, ".");
                //保证.只出现一次，而不能出现两次以上
                value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");

                if (value / 1 < 0) {
                    value = 0;
                }
                if (value.toString().indexOf(".") != -1) {
                    if (value.toString().split(".")[1].length > 2) {
                        value = Math.floor(value * 100) / 100
                    }
                }
                this.fareIncrease = value;
            },
            //输入最低供应量
            minSupplyChange: function(e) {
                let value = e.replace(/^(0+)|[^\d]+/g, '');
                this.minSupply = value;
            },
            //输入总量
            totalAmountChange: function(e) {
                let value = e.replace(/^(0+)|[^\d]+/g, '');
                this.totalAmount = value;
            },
            //输入交货周期
            deliveryCycleChange: function(e) {
                let value = e.replace(/^(0+)|[^\d]+/g, '');
                this.deliveryCycle = value;
            },
            lazyLoad(node, resolve) {
                let that = this;
                if (node.level == 1) {
                    this.request.get(this.$store.state.httpUrl + "mobileInterf/queryProductTwo", {
                        params: {
                            userId: this.$store.state.userId,
                            productId: node.value
                        }
                    }).then(res => {
                        if (res.status == 200) {
                            if (res.data.length > 0) {
                                const nodes = res.data.map(item => {
                                    return {
                                        name: item.msg,
                                        id: item.code,
                                        leaf: 2
                                    }
                                })
                                resolve(nodes);
                            } else {
                                resolve([]);
                            }
                        }
                    });
                } else {
                    resolve([]);
                }
            },
            handleChange(product) {
                let arr = this.$refs.cascader.getCheckedNodes()[0].pathNodes;
                if (product.length > 1) {
                    this.productName = arr[0].data.name;
                    this.productId = product[0];
                    this.productValue = arr[1].data.name;
                    this.productCode = product[1];
                } else {
                    this.productName = arr[0].data.name;
                    this.productId = product[0];
                }
                this.location = '';
                this.locationList = [];
                this.getWareHouseList();
            },
            //二级产品列表
            getProductTwo(id, index, arr) {
                this.request.get(this.$store.state.httpUrl + "mobileInterf/queryProductTwo", {
                    params: {
                        userId: this.$store.state.userId,
                        productId: id
                    }
                }).then(res => {
                    if (res.status == 200) {
                        if (res.data.length > 0) {
                            res.data.forEach(item => {
                                item.name = item.msg;
                                item.id = item.code;
                            })
                            arr[index].children = res.data;
                        }
                    }
                    if (index == arr.length - 1) {
                        this.productList = arr;
                    }
                });
            },
            //一级产品列表
            getProductList() {
                let that = this;
                // byProduct/queryList
                this.request.post(this.$store.state.httpUrl + "byProduct/queryList-ry", {
                    userId: this.$store.state.orgCode
                }).then(res => {
                    if (res.status == 200) {
                        let arr = [];
                        res.data.forEach(item => {
                            arr = arr.concat(item.list);
                        })
                        this.productList = arr;
                        // arr.forEach((item, index) => {
                        //     item.children = that.getProductTwo(item.id, index, arr);
                        // })
                    }
                });
            },
            //获取自提仓库
            getWareHouseList: function() {
                this.request.get(this.$store.state.httpUrl + "mobileInterf/queryWarehouse", {
                    params: {
                        productId: this.productId
                    }
                }).then(res => {
                    if (res.status == 200) {
                        res.data.forEach(item => {
                            if (item.children.length <= 0) {
                                delete item.children;
                            }
                        })
                        this.pickCityList = res.data;
                        console.log(this.pickCityList)
                    }
                });
            },
            //获取加价方式列表
            getunitedList: function() {
                let that = this;
                this.request.get(this.$store.state.httpUrl + "united/unitedList", {
                    params: {}
                }).then(res => {
                    if (res.status == 200) {
                        this.unitedList = res.data;
                    }
                });

                this.request.get(this.$store.state.httpUrl + "unit/unitList", {
                    params: {}
                }).then(res => {
                    if (res.status == 200) {
                        this.numUnitList = res.data;
                    }
                });
            },
            getUserList() {
                this.request.get(this.$store.state.httpUrl + "userRelated/user/certifiedUser", {
                    params: {
                        ouserId: this.$store.state.userId,
                        search: this.userKw
                    }
                }).then(res => {
                    if (res.status == 200) {
                        this.userList = res.data;
                    }
                });
            },
            handleAvatarSuccess(res, file) {
                this.imageUrl = URL.createObjectURL(file.raw);
            },
            beforeAvatarUpload(file) {
                const isJPG = file.type === 'image/jpeg';
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isJPG) {
                    this.$message.error('上传头像图片只能是 JPG 格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 2MB!');
                }
                return isJPG && isLt2M;
            }
        }
    };
</script>

<style scoped>
    .items {
        width: 100%;
        display: flex;
        justify-content: space-between;
    }

    .items>div {
        width: calc(50% - 20px);
    }

    .w50 {
        width: calc(50% - 20px);
    }

    .item {
        display: flex;
        text-align: left;
        margin-top: 24px;
    }

    .item>div:nth-child(1) {
        width: 110px;
        font-size: 14px;
        color: #999999;
        line-height: 36px;
    }

    .item2>div:nth-child(1) {
        line-height: 40px;
    }

    .item3>div:nth-child(1) {
        line-height: 1;
    }

    .item>div:nth-child(2) {
        width: calc(100% - 110px);
    }

    .mdList {
        padding-left: 110px;
        margin-top: 14px;
    }

    .mdList>div {
        height: 121px;
        background: #EEF3FF;
        border: 1px solid #D70606;
        border-radius: 10px;
        padding: 0 24px;
    }

    .mdList>div>div:nth-child(1) {
        display: flex;
        justify-content: space-between;
        margin-top: 12px;
    }

    .mdList>div>div:nth-child(2) {
        margin-top: 12px;
    }

    .mdList>div>div:nth-child(2)>div {
        margin-bottom: 10px;
    }

    .avatar-uploader {
        width: 180px;
        height: 100px;
        background: #EBF1FF;
        border-radius: 10px;
        box-sizing: border-box;
        text-align: center;
    }

    .avatar-uploader .avatar {
        width: 180px;
        height: 100px;
        border-radius: 10px;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload--text {
        width: 100%;
        height: 100%;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 36px;
        color: #BAD0FF;
        margin-top: 20px;
    }

    .avatar-uploader-txt {
        font-size: 14px;
        color: #82ABFF;
        margin-top: 8px;
        width: 180px;
        padding-bottom: 20px;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .btn {
        display: flex;
        padding-left: 110px;
        margin-top: 36px;
        padding-bottom: 50px;
    }

    .btn>div {
        width: 196px;
        height: 48px;
        background: #D70606;
        border-radius: 5px;
        text-align: center;
        line-height: 48px;
        font-size: 16px;
        color: #FFFFFF;
        margin-right: 32px;
        box-sizing: border-box;
        cursor: pointer;
    }

    .btn>div:nth-child(2) {
        border: 1px solid #D70606;
        background: #FFFFFF;
        border-radius: 5px;
        color: #D70606;
    }

    .mark {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
    }

    .userList {
        width: 400px;
        height: 400px;
        background: #FFFFFF;
        box-shadow: 0px 1px 7px 0px rgba(58, 138, 250, 0.35);
        border-radius: 15px;
        position: fixed;
        top: calc(50% - 200px);
        left: calc(50% - 200px);
        z-index: 9;
        overflow: hidden;
    }

    .userList>div {
        box-sizing: border-box;
    }

    .userList>div:nth-child(1) {
        background: #6698FE;
        height: 36px;
        line-height: 36px;
        display: flex;
        justify-content: space-between;
        color: #FFFFFF;
        padding: 0 20px;
    }

    .userList>div:nth-child(2) {
        padding: 0 20px;
        padding-top: 20px;
    }

    .userList>.list {
        padding: 20px;
    }

    .userList>.list>div {
        height: 210px;
        background: #F4F7FF;
        border-radius: 10px;
        overflow-y: auto;
        padding: 14px;
        box-sizing: border-box;
        text-align: left;
    }

    .userList>.list>div .userItem {
        margin-bottom: 14px;
    }

    .userList>div:nth-child(4) {
        width: 230px;
        height: 40px;
        background: #6698FE;
        border-radius: 5px;
        text-align: center;
        line-height: 40px;
        font-size: 14px;
        font-weight: 400;
        color: #FFFFFF;
        margin: 0 auto;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/view/me/publishJP.vue